import React from "react";
import { ErrorOutline as AlertCircle } from "@mui/icons-material";
import styles from "./ErrorBanner.module.css";

function ErrorBanner({ message }) {
  return (
    <div className={styles.banner}>
      <AlertCircle sx={{ fontSize: 16 }} className={styles.icon} />
      <span>{message}</span>
    </div>
  );
}

export default React.memo(ErrorBanner);
